import { GOAL_EVENT_TYPE } from '@/constants/goal'
import { INITIATIVE_EVENT_TYPE, INITIATIVE_FIELDS } from '@/constants/initiative'

export const AWARD_TYPE = {
  CHECKIN: 'checkin',
  INITIATIVE: 'initiative',
  KEY_RESULT: 'key_result',
  GOAL: 'goal',
  INITIATIVE_STATUS: 'initiative_status',
  GOAL_COMMENT: 'goal_comment',
  INITIATIVE_COMMENT: 'initiative_comment'
}

export const EVENT_OTYPE = {
  GOAL_EVENT: 'goal_event',
  INITIATIVE_EVENT: 'initiative_event'
}

export const EVENT_AWARD_TYPE = {
  goal: {
    [GOAL_EVENT_TYPE.COMMENT]: AWARD_TYPE.GOAL_COMMENT,
    [GOAL_EVENT_TYPE.CHECKIN]: AWARD_TYPE.CHECKIN
  },
  initiative: {
    [INITIATIVE_EVENT_TYPE.COMMENT]: AWARD_TYPE.INITIATIVE_COMMENT,
    [`${INITIATIVE_EVENT_TYPE.FIELD_CHANGED}-${
      INITIATIVE_FIELDS.STATUS.id
    }`]: AWARD_TYPE.INITIATIVE_STATUS
  }
}
